import { CloudOff, RefreshCw } from 'lucide-react';
import { useOnline } from '@/lib/hooks';
import { usePendingCount } from '@/data/queries';
import { useSyncStatus, syncNow } from '@/sync/status';
import { useSession } from '@/state/session';
import { cn } from '@/lib/cn';

/** Small sync state: offline, pending changes, syncing, or nothing when all is up to date. */
export function SyncIndicator() {
  const online = useOnline();
  const pending = usePendingCount();
  const { syncing, lastError } = useSyncStatus();
  const mode = useSession((s) => s.mode);
  if (mode === 'demo')
    return (
      <span className="rounded-xs bg-primary-soft px-1.5 py-0.5 text-cap text-primary-ink">
        Demo data
      </span>
    );
  if (!online)
    return (
      <span
        className="flex items-center gap-1 text-cap text-today"
        title="Offline: changes are saved here and sync when you reconnect"
      >
        <CloudOff className="size-3.5" />
        Offline{pending ? ` · ${pending} to sync` : ''}
      </span>
    );
  if (!pending && !syncing && !lastError) return null;
  return (
    <button
      onClick={() => void syncNow()}
      title={lastError ? `Sync problem: ${lastError}. Click to retry.` : 'Sync now'}
      className={cn(
        'flex items-center gap-1 rounded-sm px-1.5 py-0.5 text-cap hover:bg-surface-2',
        lastError ? 'text-overdue' : 'text-ink-3',
      )}
    >
      <RefreshCw className={cn('size-3.5', syncing && 'animate-spin')} />
      {lastError ? 'Retry sync' : pending ? `${pending} to sync` : 'Syncing'}
    </button>
  );
}
